/* Utilities to format specific type of values, like coefficients de capitalisation, etc. */

import {
  fCurrency,
  fDecimalNumber,
  fPercent,
} from '@norma/shared/helpers/formatNumber';
import { Unite } from '@norma/shared/types/prejudice.type';
import i18next from 'i18next';

export const fCoefficientCapitalisation = (value: number) => {
  return fDecimalNumber(value, 3);
};

export const fPartResponsabilite = (value: number) => {
  return fPercent(value, 2);
};

export const fCurrencyUnite = (value: number, unite: Unite) => {
  return i18next.t('prejudice.fields.unite.print.value', {
    unite,
    value: fCurrency(value),
  });
};
